<template>
  <Header />
  <Herosection />
  <MysteriesOfTheRosary />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Herosection from "@/components/HeroSectionPage.vue";
import Footer from "@/components/Footer.vue";
import MysteriesOfTheRosary from "@/components/prayers/MysteriesOfTheRosary.vue";

export default {
  components: {
    Header,
    Footer,
    Herosection,
    MysteriesOfTheRosary,
  },
};
</script>
